import {
    RESET_WIZARD,
    SET_ACTIVE_STEP,
    SET_AGENT_NAME,
    SET_DASHBOARD_BULK_CREATED,
    SET_EQUIPMENT_CREATED,
    SET_EQUIPMENT_PROCESS_DATA,
    SET_EQUIPMENT_PROCESS_IDS,
    SET_EQUIPMENT_TYPE_NAME,
    SET_AW_LOAD_MESSAGE,
    SET_AW_MESSAGE_MODAL_OPEN,
    SET_AW_PROCESS_IDS,
    SET_AW_TOTAL_SENSORS,
    SET_PROFILE_NAME,
    SET_SENSOR_PROCESS_DATA,
    SET_SENSOR_PROCESS_IDS,
    SET_SENSORS_CREATED,
    SET_SENSORS_CREATED_EVENT,
    SET_SENSORS_ERROR_DETAILS,
    SET_SUMMARIES,
    SET_TARGET_AGENT,
    SET_TARGET_DEVICES,
    SET_TARGET_EQUIPMENT,
    SET_TARGET_EQUIPMENT_CONFIG,
    SET_TARGET_PROFILES,
    SET_TARGET_PROFILE,
    SET_TARGET_PROFILE_OBJECTS,
    SET_TARGET_SENSORS,
    SET_TARGET_SITE,
    SET_WIZARD_COMPLETE,
    SET_VALIDATE_FORM
} from '../actions/actionTypes';

const initialState = {
    steps: [
        'Select Agent',
        'Select Profile',
        'Configure Equipment',
        'Create Equipment',
        'Map Objects to Sensors',
        'Create Sensors'
    ],
    activeStep:            0,
    agentName:             '',
    dashboardBulkComplete: null,
    equipmentCreated:      false,
    equipmentProcessData:  [],
    equipmentProcessIds:   [],
    equipmentTypeName:     '',
    isMessageModalOpen:    false,
    message:               '',
    processIds:            [],
    profileName:           '',
    sensorProcessData:     [],
    sensorProcessIds:      [],
    sensorsCreated:        false,
    summaries:             [],
    targetAgent:           {},
    targetDevices:         [],
    targetEquipment:       [],
    targetEquipmentConfig: {},
    targetProfiles:        [],
    targetProfile:         {},
    targetProfileObjects:  [],
    targetSensors:         [],
    targetSite:            '',
    totalSensors:          0,
    wizardComplete:        false,
    validateForm:          false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case RESET_WIZARD:
            return {
                ...state,
                ...initialState
            };
        case SET_ACTIVE_STEP:
            return {
                ...state,
                activeStep: action.payload
            };
        case SET_AGENT_NAME:
            return {
                ...state,
                agentName: action.payload
            };
        case SET_AW_LOAD_MESSAGE:
            return {
                ...state,
                message: action.payload
            };
        case SET_AW_MESSAGE_MODAL_OPEN:
            return {
                ...state,
                isMessageModalOpen: action.payload
            };
        case SET_AW_TOTAL_SENSORS:
            return {
                ...state,
                totalSensors: action.payload
            };
        case SET_AW_PROCESS_IDS:
            return {
                ...state,
                processIds: [...action.payload]
            };
        case SET_DASHBOARD_BULK_CREATED:
            return {
                ...state,
                dashboardBulkComplete: action.payload
            };
        case SET_EQUIPMENT_CREATED:
            return {
                ...state,
                equipmentCreated: action.payload
            };
        case SET_EQUIPMENT_PROCESS_DATA:
            return {
                ...state,
                equipmentProcessData: [...action.payload]
            };
        case SET_EQUIPMENT_PROCESS_IDS:
            return {
                ...state,
                equipmentProcessIds: [...action.payload]
            };
        case SET_EQUIPMENT_TYPE_NAME:
            return {
                ...state,
                equipmentTypeName: action.payload
            };
        case SET_PROFILE_NAME:
            return {
                ...state,
                profileName: action.payload
            };
        case SET_SENSOR_PROCESS_DATA:
            return {
                ...state,
                sensorProcessData: [...action.payload]
            };
        case SET_SENSOR_PROCESS_IDS:
            return {
                ...state,
                sensorProcessIds: [...action.payload]
            };
        case SET_SENSORS_CREATED:
            return {
                ...state,
                sensorsCreated: action.payload
            };
            
        case SET_SENSORS_CREATED_EVENT:
            return {
                ...state,
                sensorsCreatedEvent: action.payload
            };
        case SET_SENSORS_ERROR_DETAILS:
            return {
                ...state,
                sensorErrorObj: action.payload
            };
        case SET_SUMMARIES:
            return {
                ...state,
                summaries: [...action.payload]
            };
        case SET_TARGET_AGENT:
            return {
                ...state,
                targetAgent: {...action.payload}
            };
        case SET_TARGET_DEVICES:
            return {
                ...state,
                targetDevices: [...action.payload]
            };
        case SET_TARGET_EQUIPMENT:
            return {
                ...state,
                targetEquipment: [...action.payload]
            };
        case SET_TARGET_EQUIPMENT_CONFIG:
            return {
                ...state,
                targetEquipmentConfig: {...action.payload}
            };
        case SET_TARGET_PROFILES:
            return {
                ...state,
                targetProfiles: [...action.payload]
            };
        case SET_TARGET_PROFILE:
            return {
                ...state,
                targetProfile: {...action.payload}
            };
        case SET_TARGET_PROFILE_OBJECTS:
            return {
                ...state,
                targetProfileObjects: [...action.payload]
            };
        case SET_TARGET_SENSORS:
            return {
                ...state,
                targetSensors: [...action.payload]
            };
        case SET_TARGET_SITE:
            return {
                ...state,
                targetSite: action.payload
            };
        case SET_WIZARD_COMPLETE:
            return {
                ...state,
                wizardComplete: action.payload
            };
        case SET_VALIDATE_FORM:
            return {
                ...state,
                validateForm: action.payload
            };
        default:
            return state;
    }
};
